"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useState } from "react";
export default function () {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <section data-section-id="4245" id="aboutworkshop" className="light bg-background text-foreground relative overflow-hidden py-32 md:py-48 lg:py-[200px] px-6 md:px-12 lg:px-8">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 lg:gap-20">
          {}
          <div ref={leftRef} className="lg:col-span-4 transition-all duration-1000 ease-out opacity-100 translate-y-0">
            {}
            

            {}
            <h2 className="font-default font-bold leading-[0.88] tracking-tighter text-foreground text-[64px] sm:text-[88px] md:text-[110px] lg:text-[132px] mb-16 md:mb-20">
              
              
              <span className="block !text-[rgba(0,0,0,1)]">About <br />TM Plant</span>
            </h2>

            {}
            <div className="max-w-[900px] font-default text-[19px] leading-[1.7] text-foreground space-y-7">
              <p className="relative"><span className="float-left font-default font-bold leading-[0.85] mr-3 mt-1 !text-[rgba(0,0,0,1)]" data-ast-id="f:/src/pages/About/sections/About.tsx|sig:7f3l5y" data-ast-start="1680" data-ast-end="1951" style={{
                fontSize: '96px'
              }}>T</span>M Plant was established in 2022, but our story began much earlier. Our founder, Toby, has over 22 years of experience in the repair, servicing, and maintenance of construction and industrial machinery. Toby started his career with a leading tool hire company in London, where he spent 17 years gaining extensive hands-on experience, developing his technical expertise, and working with a wide range of equipment while supporting customers across various industries. After relocating to Cumbria with his family, Toby decided to turn his years of experience into his own business by founding TM Plant Carlisle. <br /><br />Through honesty, dedication, and hard work, the company has continued to grow, earning the trust of customers and building a strong reputation for reliable, high-quality service. We are a family-run business that takes pride in delivering a personal and professional service. Whether you're an individual customer, an independent contractor, or a large company looking for a reliable long-term service partner, every customer receives the same level of care, respect, and commitment. <br /><br />We believe that our reputation is built on the satisfaction of our customers. That's why we provide honest advice, dependable workmanship, and complete every job to the highest standard. Our goal is not only to repair and maintain your machinery but also to build lasting relationships based on trust, reliability, and exceptional customer service. At TM Plant, experience, integrity, and passion are at the heart of everything we do. If you're looking for a service partner you can rely on to keep your machinery running safely and efficiently, we're here to help.</p>

              

              {}
              <blockquote className="border-l-2 border-primary pl-6 md:pl-8 my-12 md:my-14">
                
              </blockquote>

              

              
            </div>
          </div>

          {}
          
        </div>
      </div>
    </section>;
}